/**
 * Generated by orval 🍺
 * Do not edit manually.
 * DomainService API
 * API reference for handling domain data provided by DomainService.
 *
 * # Authentication
 * This API is stateful. Therefore, it is necessary to call with the authentication information set in the cookie.
 * More specifically, it authenticates using Auth0.
 * Please set in header before calling API
 *  - x-solution-id
 *  - x-client-id
 *  - Authorization
 *  - Cookie.
 *
 * OpenAPI spec version: 1.0.0
 */
import type {
  BaseSuccessResponse,
  BeginUploadReferencePointCloudRequest,
  BulkUpsertStructuresRequest,
  BulkUpsertStructuresResponseResponse,
  CreateStructure3dModelRequest,
  CreateStructureRequest,
  CreateThreeDModelReferencePointRequest,
  CreateTwoDReferencePointRequest,
  DeleteStructureRequest,
  ListAllReferencePointCloudsParams,
  ListReferencePointCloudsParams,
  ListStructuresParams,
  N2DReferencePointNullableResponse,
  N2DReferencePointResponse,
  N2DReferencePointsResponse,
  N3DModelReferencePointNullableResponse,
  N3DModelReferencePointResponse,
  N3DModelReferencePointsResponse,
  ReferencePointCloudBeginUploadResponse,
  ReferencePointCloudDeletedResponse,
  ReferencePointCloudEndUploadResponse,
  ReferencePointCloudResponse,
  ReferencePointCloudsAllResponse,
  ReferencePointCloudsResponse,
  SearchStructure3DModelsParams,
  Structure3dModelResponse,
  Structure3dModelsWithChildrenResponse,
  StructureResponse,
  StructuresResponse,
  UpdateStructure3dModelRequest,
  UpdateStructureRequest,
  UpdateStructureTreeOrderBody
} from '../model';

import listStructuresMutator from '../../../mutators/domain-service-instance';
import createStructureMutator from '../../../mutators/domain-service-instance';
import getStructureMutator from '../../../mutators/domain-service-instance';
import updateStructureMutator from '../../../mutators/domain-service-instance';
import deleteStructureMutator from '../../../mutators/domain-service-instance';
import updateStructureTreeOrderMutator from '../../../mutators/domain-service-instance';
import bulkUpsertStructuresMutator from '../../../mutators/domain-service-instance';
import searchStructure3DModelsMutator from '../../../mutators/domain-service-instance';
import createStructure3DModelMutator from '../../../mutators/domain-service-instance';
import updateStructure3DModelMutator from '../../../mutators/domain-service-instance';
import deleteStructure3DModelMutator from '../../../mutators/domain-service-instance';
import getLatest3DModelReferencePointMutator from '../../../mutators/domain-service-instance';
import list3DModelReferencePointsMutator from '../../../mutators/domain-service-instance';
import create3DModelReferencePointMutator from '../../../mutators/domain-service-instance';
import delete3DModelReferencePointMutator from '../../../mutators/domain-service-instance';
import getLatest2DReferencePointMutator from '../../../mutators/domain-service-instance';
import list2DReferencePointsMutator from '../../../mutators/domain-service-instance';
import create2DReferencePointMutator from '../../../mutators/domain-service-instance';
import delete2DReferencePointMutator from '../../../mutators/domain-service-instance';
import listAllReferencePointCloudsMutator from '../../../mutators/domain-service-instance';
import listReferencePointCloudsMutator from '../../../mutators/domain-service-instance';
import beginUploadReferencePointCloudMutator from '../../../mutators/domain-service-instance';
import endUploadReferencePointCloudMutator from '../../../mutators/domain-service-instance';
import getReferencePointCloudMutator from '../../../mutators/domain-service-instance';
import deleteReferencePointCloudMutator from '../../../mutators/domain-service-instance';



  /**
 * Returns a list of structures of the specified type.
 * You can choose between tree format and simple list format by specifying the "as_tree" parameter.
 * @summary List structures
 */
export const listStructures = (
    params?: ListStructuresParams,
 ) => {
      return listStructuresMutator<StructuresResponse>(
      {url: `/structures`, method: 'GET',
        params
    },
      );
    }
  /**
 * Create Structure
 *
 * Returns 409 when a structure with the same `name` already exists under the same `path`:
 * among structures of the same type for the power grid distribution types (23-26),
 * and among all siblings for site (5), turbine (6) and electric_tower (12)
 * (a duplicated `turbine_number` / `sequence_no` is also rejected for turbine / electric_tower).
 * For a duplicated name, `error.message` is `target name(<name>) is duplicated`.
 * For the power grid distribution types the name is compared by the database (case-insensitive by default collation); for 5, 6 and 12 it is an exact match.
 * @summary Create Structure
 */
export const createStructure = (
    createStructureRequest: CreateStructureRequest,
 ) => {
      return createStructureMutator<StructureResponse>(
      {url: `/structures`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createStructureRequest
    },
      );
    }
  /**
 * Returns a details of structure of the specified id.
 * @summary Get Structure
 */
export const getStructure = (
    id: number,
 ) => {
      return getStructureMutator<StructureResponse>(
      {url: `/structures/${id}`, method: 'GET'
    },
      );
    }
  /**
 * Update Structure
 *
 * Behavior to be aware of:
 * - `structure_type_id` is required. It only selects the validation rules; the type of the structure is not changed.
 * - If `coordinate` is omitted, the position is overwritten with (0, 0). Send the coordinate every time for a structure that has one.
 * - If `path` is omitted, the current value is kept. If it is sent, the structure is moved under that parent.
 *   Only this structure's `path` changes: the `path` of its descendants is not rewritten, so they keep pointing at the old ancestors.
 * - For a power grid distribution pole (26), a property of `attributes` that is omitted keeps its current value, and `null` clears it.
 *   `height_above_ground` and `elevation` are independent of each other. `attributes` itself is still required and must not be empty.
 *   To change only other fields (e.g. `name`, `coordinate`), resend the current value of at least one property.
 *   Sending `{"height_above_ground": null, "elevation": null}` clears both values.
 * - Changing `coordinate` does not change `elevation` by itself. Send the elevation for the new location (or `null`) in the same request.
 * - Returns 409 on a duplicated name under the same `path`, in the same way as Create Structure.
 *   Renaming a structure or moving it under another parent is checked as well; the structure itself is not counted.
 * @summary Update Structure
 */
export const updateStructure = (
    id: number,
    updateStructureRequest: UpdateStructureRequest,
 ) => {
      return updateStructureMutator<StructureResponse>(
      {url: `/structures/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updateStructureRequest
    },
      );
    }
  /**
 * Delete structure and then rearrange tree
 * @summary Delete Structure
 */
export const deleteStructure = (
    id: number,
    deleteStructureRequest?: DeleteStructureRequest,
 ) => {
      return deleteStructureMutator<BaseSuccessResponse>(
      {url: `/structures/${id}`, method: 'DELETE',
      headers: {'Content-Type': 'application/json', },
      data: deleteStructureRequest
    },
      );
    }
  /**
 * Update Structure Tree Order
 */
export const updateStructureTreeOrder = (
    updateStructureTreeOrderBody: UpdateStructureTreeOrderBody,
 ) => {
      return updateStructureTreeOrderMutator<BaseSuccessResponse>(
      {url: `/structures/update_tree`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: updateStructureTreeOrderBody
    },
      );
    }
  /**
 * ゲンコネから設備（施設およびフロア）を一括作成または更新します。
 * 設備のレコードと、それに対応する genkone_attributes のマッピングの両方を作成します。「order」 フィールドで指定された順序で項目を処理します。
 * @summary Bulk Upsert Structures
 */
export const bulkUpsertStructures = (
    bulkUpsertStructuresRequest: BulkUpsertStructuresRequest,
 ) => {
      return bulkUpsertStructuresMutator<BulkUpsertStructuresResponseResponse>(
      {url: `/structures/bulk-upsert`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: bulkUpsertStructuresRequest
    },
      );
    }
  /**
 * 3Dモデルを検索します。
 *
 * **検索方法:**
 * - `structure_id` で検索: 設備IDを指定して検索
 * - `genkone_id` + `type` で検索: ゲンコネIDと種類を指定して検索
 *
 * **注意:** `structure_id` と `genkone_id`/`type` は同時に指定できません。
 *
 * **required_attribute について:**
 * - `structure_id` で検索する場合、`required_attribute=genkone` を指定すると、ゲンコネ属性を持つ設備のみを対象とします
 * - `structure_id` のみの場合は、ゲンコネ属性の有無に関わらず全ての設備を対象とします
 * - `genkone_id` + `type` で検索する場合は、暗黙的にゲンコネ属性を持つ設備のみを対象とします
 * @summary Search Structure 3D Models
 */
export const searchStructure3DModels = (
    params?: SearchStructure3DModelsParams,
 ) => {
      return searchStructure3DModelsMutator<Structure3dModelsWithChildrenResponse>(
      {url: `/structures/3d-models`, method: 'GET',
        params
    },
      );
    }
  /**
 * 3Dモデルを新規作成します。
 * 内部的に structure_genkone_attributes テーブルを使用して genkone_id を structure_id に変換します。
 * @summary Create Structure 3D Model
 */
export const createStructure3DModel = (
    createStructure3dModelRequest: CreateStructure3dModelRequest,
 ) => {
      return createStructure3DModelMutator<Structure3dModelResponse>(
      {url: `/structures/3d-models`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createStructure3dModelRequest
    },
      );
    }
  /**
 * 既存の3Dモデルを更新します。
 * 組織IDはstructureのリレーションを通じて検証されます。
 * @summary Update Structure 3D Model
 */
export const updateStructure3DModel = (
    id: number,
    updateStructure3dModelRequest: UpdateStructure3dModelRequest,
 ) => {
      return updateStructure3DModelMutator<Structure3dModelResponse>(
      {url: `/structures/3d-models/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updateStructure3dModelRequest
    },
      );
    }
  /**
 * 3Dモデルを削除します。
 * 組織IDはstructureのリレーションを通じて検証されます。
 * @summary Delete Structure 3D Model
 */
export const deleteStructure3DModel = (
    id: number,
 ) => {
      return deleteStructure3DModelMutator<BaseSuccessResponse>(
      {url: `/structures/3d-models/${id}`, method: 'DELETE'
    },
      );
    }
  /**
 * 指定した3Dモデルの最新の基準点（centerGps）を取得します。
 * 基準点が存在しない場合は null を返します。
 * @summary Get latest reference point for a 3D model
 */
export const getLatest3DModelReferencePoint = (
    modelId: number,
 ) => {
      return getLatest3DModelReferencePointMutator<N3DModelReferencePointNullableResponse>(
      {url: `/structures/3d-models/${modelId}/reference-points/latest`, method: 'GET'
    },
      );
    }
  /**
 * 指定した3Dモデルの全ての基準点（centerGps）を取得します。
 * 基準点が存在しない場合は空配列を返します。
 * @summary List all reference points for a 3D model
 */
export const list3DModelReferencePoints = (
    modelId: number,
 ) => {
      return list3DModelReferencePointsMutator<N3DModelReferencePointsResponse>(
      {url: `/structures/3d-models/${modelId}/reference-points`, method: 'GET'
    },
      );
    }
  /**
 * 3Dモデルの基準点（centerGps）を新規作成します。
 * 同じ3Dモデルに対して複数の基準点を作成できます。
 * @summary Create a reference point for a 3D model
 */
export const create3DModelReferencePoint = (
    modelId: number,
    createThreeDModelReferencePointRequest: CreateThreeDModelReferencePointRequest,
 ) => {
      return create3DModelReferencePointMutator<N3DModelReferencePointResponse>(
      {url: `/structures/3d-models/${modelId}/reference-points`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createThreeDModelReferencePointRequest
    },
      );
    }
  /**
 * 基準点を削除します。
 * @summary Delete a reference point
 */
export const delete3DModelReferencePoint = (
    modelId: number,
    id: number,
 ) => {
      return delete3DModelReferencePointMutator<BaseSuccessResponse>(
      {url: `/structures/3d-models/${modelId}/reference-points/${id}`, method: 'DELETE'
    },
      );
    }
  /**
 * 指定した設備の最新の2D基準点（centerGps）を取得します。
 * 基準点が存在しない場合は null を返します。
 * @summary Get latest 2D reference point for a structure
 */
export const getLatest2DReferencePoint = (
    structureId: number,
 ) => {
      return getLatest2DReferencePointMutator<N2DReferencePointNullableResponse>(
      {url: `/structures/${structureId}/2d-reference-points/latest`, method: 'GET'
    },
      );
    }
  /**
 * 指定した設備の全ての2D基準点（centerGps）を取得します。
 * 基準点が存在しない場合は空配列を返します。
 * @summary List all 2D reference points for a structure
 */
export const list2DReferencePoints = (
    structureId: number,
 ) => {
      return list2DReferencePointsMutator<N2DReferencePointsResponse>(
      {url: `/structures/${structureId}/2d-reference-points`, method: 'GET'
    },
      );
    }
  /**
 * 設備の2D基準点（centerGps）を新規作成します。
 * 同じ設備に対して複数の基準点を作成できます。position はピクセル座標（y は常に 0）です。
 * @summary Create a 2D reference point for a structure
 */
export const create2DReferencePoint = (
    structureId: number,
    createTwoDReferencePointRequest: CreateTwoDReferencePointRequest,
 ) => {
      return create2DReferencePointMutator<N2DReferencePointResponse>(
      {url: `/structures/${structureId}/2d-reference-points`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createTwoDReferencePointRequest
    },
      );
    }
  /**
 * 2D基準点を削除します。structure_id と id の両方で絞り込みます。
 * @summary Delete a 2D reference point
 */
export const delete2DReferencePoint = (
    structureId: number,
    id: number,
 ) => {
      return delete2DReferencePointMutator<BaseSuccessResponse>(
      {url: `/structures/${structureId}/2d-reference-points/${id}`, method: 'DELETE'
    },
      );
    }
  /**
 * 組織内の基準点群を横断的に一覧します（設備コンテキストなし）。ビューアの
 * /reference-point-clouds 画面が利用します。設備スコープの一覧は
 * GET /structures/reference-point-clouds（structure_id 必須）を使ってください。
 * 既定では status=uploaded のみを返します。ページネーション必須（limit / offset）。
 * 各行に structure_name を含みますが、行ごとのダウンロード SAS は発行しないため
 * download_url / expires_at は常に null です。組織分離は structures との結合のみで担保されます。
 * @summary List all reference point clouds (organization-wide)
 */
export const listAllReferencePointClouds = (
    params?: ListAllReferencePointCloudsParams,
 ) => {
      return listAllReferencePointCloudsMutator<ReferencePointCloudsAllResponse>(
      {url: `/reference-point-clouds`, method: 'GET',
        params
    },
      );
    }
  /**
 * 設備に紐づく基準点群の一覧を取得します。
 * 既定では status=uploaded のレコードのみを返します（status を明示すると pending / failed も取得可能）。
 * 一覧では行ごとのダウンロード SAS を発行しないため、download_url / expires_at は常に null です。
 * @summary List reference point clouds
 */
export const listReferencePointClouds = (
    params: ListReferencePointCloudsParams,
 ) => {
      return listReferencePointCloudsMutator<ReferencePointCloudsResponse>(
      {url: `/structures/reference-point-clouds`, method: 'GET',
        params
    },
      );
    }
  /**
 * アップロードを開始します。設備を検証して pending 行を作成し、
 * Azure Blob へ直接 PUT するための書き込み用 SAS URL を返します。
 * クライアントは upload_url に LAS を PUT した後、end-upload で確定します。
 * @summary Begin reference point cloud upload
 */
export const beginUploadReferencePointCloud = (
    beginUploadReferencePointCloudRequest: BeginUploadReferencePointCloudRequest,
 ) => {
      return beginUploadReferencePointCloudMutator<ReferencePointCloudBeginUploadResponse>(
      {url: `/structures/reference-point-clouds/begin-upload`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: beginUploadReferencePointCloudRequest
    },
      );
    }
  /**
 * Blob の存在を確認して現状と整合させる（reconcile）エンドポイント。冪等。
 * uploaded 済みの再呼び出しは現状を返します。pending / failed いずれの行でも、
 * Blob が存在すれば uploaded に更新します（一度 failed になった行も、再 PUT 後の
 * 再呼び出しで復帰できる = 再試行可能）。Blob が存在しない場合は failed に更新して 422 を返します。
 * @summary End reference point cloud upload
 */
export const endUploadReferencePointCloud = (
    id: number,
 ) => {
      return endUploadReferencePointCloudMutator<ReferencePointCloudEndUploadResponse>(
      {url: `/structures/reference-point-clouds/${id}/end-upload`, method: 'POST'
    },
      );
    }
  /**
 * 基準点群を 1 件取得します。status=uploaded のときのみ読み取り専用のダウンロード SAS
 * （download_url / expires_at）を含みます。それ以外は download_url / expires_at は null です。
 * @summary Get reference point cloud
 */
export const getReferencePointCloud = (
    id: number,
 ) => {
      return getReferencePointCloudMutator<ReferencePointCloudResponse>(
      {url: `/structures/reference-point-clouds/${id}`, method: 'GET'
    },
      );
    }
  /**
 * 基準点群の DB 行を削除します。Blob 本体には触れず孤児化させます。
 * 組織 ID は structures のリレーションを通じて検証されます。
 * @summary Delete reference point cloud
 */
export const deleteReferencePointCloud = (
    id: number,
 ) => {
      return deleteReferencePointCloudMutator<ReferencePointCloudDeletedResponse>(
      {url: `/structures/reference-point-clouds/${id}`, method: 'DELETE'
    },
      );
    }
  export type ListStructuresResult = NonNullable<Awaited<ReturnType<typeof listStructures>>>
export type CreateStructureResult = NonNullable<Awaited<ReturnType<typeof createStructure>>>
export type GetStructureResult = NonNullable<Awaited<ReturnType<typeof getStructure>>>
export type UpdateStructureResult = NonNullable<Awaited<ReturnType<typeof updateStructure>>>
export type DeleteStructureResult = NonNullable<Awaited<ReturnType<typeof deleteStructure>>>
export type UpdateStructureTreeOrderResult = NonNullable<Awaited<ReturnType<typeof updateStructureTreeOrder>>>
export type BulkUpsertStructuresResult = NonNullable<Awaited<ReturnType<typeof bulkUpsertStructures>>>
export type SearchStructure3DModelsResult = NonNullable<Awaited<ReturnType<typeof searchStructure3DModels>>>
export type CreateStructure3DModelResult = NonNullable<Awaited<ReturnType<typeof createStructure3DModel>>>
export type UpdateStructure3DModelResult = NonNullable<Awaited<ReturnType<typeof updateStructure3DModel>>>
export type DeleteStructure3DModelResult = NonNullable<Awaited<ReturnType<typeof deleteStructure3DModel>>>
export type GetLatest3DModelReferencePointResult = NonNullable<Awaited<ReturnType<typeof getLatest3DModelReferencePoint>>>
export type List3DModelReferencePointsResult = NonNullable<Awaited<ReturnType<typeof list3DModelReferencePoints>>>
export type Create3DModelReferencePointResult = NonNullable<Awaited<ReturnType<typeof create3DModelReferencePoint>>>
export type Delete3DModelReferencePointResult = NonNullable<Awaited<ReturnType<typeof delete3DModelReferencePoint>>>
export type GetLatest2DReferencePointResult = NonNullable<Awaited<ReturnType<typeof getLatest2DReferencePoint>>>
export type List2DReferencePointsResult = NonNullable<Awaited<ReturnType<typeof list2DReferencePoints>>>
export type Create2DReferencePointResult = NonNullable<Awaited<ReturnType<typeof create2DReferencePoint>>>
export type Delete2DReferencePointResult = NonNullable<Awaited<ReturnType<typeof delete2DReferencePoint>>>
export type ListAllReferencePointCloudsResult = NonNullable<Awaited<ReturnType<typeof listAllReferencePointClouds>>>
export type ListReferencePointCloudsResult = NonNullable<Awaited<ReturnType<typeof listReferencePointClouds>>>
export type BeginUploadReferencePointCloudResult = NonNullable<Awaited<ReturnType<typeof beginUploadReferencePointCloud>>>
export type EndUploadReferencePointCloudResult = NonNullable<Awaited<ReturnType<typeof endUploadReferencePointCloud>>>
export type GetReferencePointCloudResult = NonNullable<Awaited<ReturnType<typeof getReferencePointCloud>>>
export type DeleteReferencePointCloudResult = NonNullable<Awaited<ReturnType<typeof deleteReferencePointCloud>>>
